<script setup lang="ts">
import logoutSmall from "assets/graphics/icons/cb_logout_small-white.svg";
import logoCareDayWhite from "assets/graphics/icons/logo_careboard_weiss.png";

const currentCareDay = useCurrentCareDay();
const careDayIdIsSet = computed(() => !!currentCareDay.value?.id);
const pathPrefix = computed(() => {
  if (!currentCareDay.value) {
    return "";
  }

  return `/careday/${currentCareDay.value.id}`;
});
const pathForRoute = (route: string) => {
  if (pathPrefix.value === "") {
    return "/";
  }

  return `/careday/${currentCareDay.value.id}/${route}`;
};

const handleLogout = () => {
  signOutUser()
    .then(() => {
      localStorage.removeItem("currentCareDay");
      navigateTo("/login");
    })
    .catch((error) => {
      console.log(error);
    });
};
</script>
<template>
  <div class="navbar navbar-dark cb_color mobile-navbar">
    <a class="navbar-brand" href="/">
      <img :src="logoCareDayWhite" style="width: 95%">
    </a>

    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#dashboardNavbar"
      aria-controls="dashboardNavbar"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon" />
    </button>
    <div id="dashboardNavbar" class="collapse navbar-collapse cb_color">
      <ul v-show="careDayIdIsSet" class="navbar-nav cb_nav">
        <NavBarLink
          :text="$t('navigation.activities')"
          icon="cb_activity_small.svg"
          :to="pathForRoute('activities')"
        />
        <NavBarLink
          :text="$t('navigation.news')"
          icon="cb_news2.svg"
          :to="pathForRoute('news')"
        />
        <NavBarLink
          :text="$t('navigation.opening_times')"
          icon="cb_time_small.svg"
          :to="pathForRoute('openingtimes')"
        />
        <NavBarLink
          :text="$t('navigation.contact_teams')"
          icon="cb_contact_small.svg"
          highlight-sub-paths
          :to="pathForRoute('contactteam')"
        />
        <NavBarLink
          :text="$t('navigation.menu')"
          icon="cb_food_small.svg"
          :to="pathForRoute('menu')"
        />
        <NavBarLink
          :text="$t('navigation.image_galleries')"
          icon="cb_pics_small.svg"
          highlight-sub-paths
          :to="pathForRoute('imagegallery')"
        />
        <NavBarLink
          :text="$t('navigation.accommodation')"
          icon="cb_residence_small.svg"
          highlight-sub-paths
          :to="pathForRoute('accommodation')"
        />
      </ul>
      <ul class="navbar-nav cb_nav">
        <NavBarLink
          :text="$t('navigation.main_news')"
          icon="info_circle"
          to="/news"
        />
        <NavBarLink
          :text="$t('navigation.help')"
          icon="helpSmall"
          to="/manuals"
        />
        <NavBarLink
          :text="$t('navigation.settings')"
          icon="settingsSmall"
          to="/settings"
        />
        <NavBarLink :text="$t('navigation.overview')" icon="homeSmall" to="/" />
        <a
          class="cb_nav-link d-flex logout-btn"
          @click="handleLogout"
        >
          <img :src="logoutSmall">
          {{ $t("navigation.log_out") }}
        </a>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.mobile-navbar {
  padding-left: 20px;
  padding-right: 20px;
  position: sticky;
  top: 0;
  z-index: 10;
}

#dashboardNavbar {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  z-index: 10;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  border-radius: 0 0 0.5rem 0.5rem;
  padding: 1rem 0;
}

.logout-btn {
  color: var(--ct_E1);
  text-decoration: none !important;
  text-transform: capitalize;
  padding: 1rem 2rem;
}
</style>
